<template>
	<compWrapper title="操作历史" theme="gray">
		<vTableSimple class="bg-fff margin-10" :columns="columns" :data="data" border stripe></vTableSimple>
	</compWrapper>	
	<!-- <div class="padding-20 bg-fff"> -->

		<!-- <Tabs type="card"> -->
			<!-- <TabPane label="操作历史记录"> -->
				
			<!-- </TabPane> -->
			<!-- <TabPane label="日志">
				<vTableSimple :columns="columnsLog" :data="data" border stripe></vTableSimple>
			</TabPane> -->
		<!-- </Tabs> -->
	<!-- </div> -->
</template>

<script>
export default {
	props: ['data'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
	},
	computed: {
		columns() {
			return [
			{
				title: "操作时间",
				key: "opAt",
			},
			{
				title: "操作人",
				key: "opUserName",
			},
			
			{
				title: "操作记录",
				key: "opAction",
			},
			{
				title: "操作日志",
				key: "opRemark",
			}
			]
		},
		// columnsLog() {
		// 	return [
		// 		{
		// 			title: "日期",
		// 			key: "opAt",
		// 		},
		// 		{
		// 			title: "消息",
		// 			key: "opRemark",
		// 		}]
		// }
	},
}
</script>
